/**
 * Resolves the axios base URL: localhost in CRA dev, same-origin /api in production.
 */
export function resolveApiBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001/api';
  }

  const configured = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
  if (!configured) {
    return '/api';
  }
  return configured.endsWith('/api') ? configured : `${configured}/api`;
}

export const API_CONFIG = {
  baseURL: resolveApiBaseUrl(),
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 * Keeps the shared config aligned with the URL chosen at startup.
 */
export const initializeAPI = async () => {
  API_CONFIG.baseURL = resolveApiBaseUrl();
};

export default API_CONFIG;
